import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaClock, FaPhoneAlt, FaTimes } from 'react-icons/fa';
import { companyInfo } from '../constants/companyInfo';
import { primaryNavLinks } from '../constants/siteLinks';

function navClass({ isActive }) {
  return `rounded-full px-3 py-2 text-sm font-semibold transition ${
    isActive
      ? 'bg-teal-700 text-white'
      : 'text-slate-700 hover:bg-slate-100 hover:text-teal-800'
  }`;
}

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <div className="bg-teal-800 py-2 text-sm text-white">
        <div className="mero-wrapper flex flex-wrap items-center justify-between gap-3">
          <p className="inline-flex items-center gap-2">
            <FaClock className="text-teal-200" /> {companyInfo.hours}
          </p>
          <p className="inline-flex items-center gap-2 font-semibold">
            <FaPhoneAlt className="text-teal-200" /> Call us now: {companyInfo.phone}
          </p>
        </div>
      </div>

      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mero-wrapper flex items-center justify-between gap-4 py-4">
          <NavLink
            to="/"
            className="inline-flex items-center gap-3 text-xl font-bold tracking-tight text-teal-800"
          >
            <img
              src="/goldenhc-logo.png"
              alt={companyInfo.displayName}
              className="h-10 w-10 rounded-full object-cover ring-1 ring-teal-200"
            />
            <span>{companyInfo.displayName}</span>
          </NavLink>

          <button
            type="button"
            className="inline-flex items-center justify-center rounded-full border border-slate-200 p-3 text-slate-700 transition hover:border-teal-200 hover:text-teal-800 md:hidden"
            onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-primary-nav"
            aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          <nav className="hidden items-center gap-2 md:flex">
            {primaryNavLinks.map((item) => (
              <NavLink key={item.to} to={item.to} className={navClass} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        {isMobileMenuOpen ? (
          <nav
            id="mobile-primary-nav"
            className="border-t border-slate-200 bg-white md:hidden"
          >
            <div className="mero-wrapper flex flex-col gap-2 py-4">
              {primaryNavLinks.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={navClass}
                  end={item.to === '/'}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </nav>
        ) : null}
      </header>
    </>
  );
}
